import React from "react";
import { Spinner } from "react-bootstrap";

export const PaypalPaymentButton = ({
  subscribeToPlanPaypal,
  loading = false,
  disabled = false,
}) => {
  return (
    <>
      <div className="text-center">
        <button
          className="paypal-btn d-flex align-items-center justify-content-center gap-2"
          type="button"
          disabled={disabled || loading}
          onClick={disabled || loading ? undefined : subscribeToPlanPaypal}
        >
          {loading ? (
            <span style={{ color: "#003087" }}>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Processing...
            </span>
          ) : (
            <span style={{ color: "#ffffff" }}>
              <i className="bi bi-paypal"></i> PayPal
            </span>
          )}
        </button>
        <small className="text-center text-xs text-gray-700 hide-sm mt-0">
          The safer, easier way to pay
        </small>
      </div>
    </>
  );
};
